import * as React from 'react';

import SwitchViewContext from './SwitchViewContext';

export class SwitchViewFragment extends React.Component {
  static displayName = 'SwitchViewFragment';
  static contextType = SwitchViewContext;

  context = null;
  removeView = null;

  componentDidMount() {
    this.removeView = this.context.addView(this.props.viewId);
  }

  componentWillUnmount() {
    if (this.removeView) {
      this.removeView();
    }
  }

  render() {
    const children = this.props.children;

    if (this.context.activeViewId !== this.props.viewId) {
      return null;
    }

    if (children instanceof Function) {
      return (
        <React.Fragment>
          {children({
            activateView: this.context.activateView,
            activeViewId: this.context.activeViewId,
          })}
        </React.Fragment>
      );
    }

    return <React.Fragment>{children}</React.Fragment>;
  }
}

export default SwitchViewFragment;
